import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import Colors from '@/constants/Colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: Colors.defaultColor,
        secondary: Colors.darkergreenblue,
        accent: Colors.greenblue,
        error: Colors.persianred,
        white: Colors.white,
        black: Colors.black,
        success: Colors.success,
        surface: Colors.darkergreenblue,
        titlebackground: Colors.sky
      },
      dark: {
        primary: Colors.defaultColor,
        secondary: Colors.darkergraygreen,
        accent: Colors.lightergraygreen,
        error: Colors.persianred,
        white: Colors.white,
        black: Colors.black,
        success: Colors.success,
        surface: Colors.darkergreenblue,
        titlebackground: Colors.sky
      }
    }
  }
})
